import StickerApi from '@/api/sticker'
import SurveyApi from '@/api/survey'
import WpWebhookApi from '@/api/wpWebhook'
import GlobalConfigurationApi from '@/api/global-configuration'
import AdsCampaignApi from '@/api/adsCampaign'
import TemplateCollectionApi from '@/api/template-collection'

const initResources = () => {
  StickerApi.initResource()
  SurveyApi.initResource()
  WpWebhookApi.initResource()
  GlobalConfigurationApi.initResource()
  AdsCampaignApi.initResource()
  TemplateCollectionApi.initResource()
}

export default {
  initResources,
}
